import { BaseService } from "@/services/BaseService";
import { AxiosInstance, AxiosResponse } from "axios";
import {
  AvalancheReport,
  AvalancheReportResponse,
  CommonReportFields,
  ObservationReport,
  ObservationReportResponse,
} from "@/services/rest/publicreply";

export class PublicReplyService {
  private static srv?: BaseService = undefined;

  private static getInstance(): AxiosInstance {
    if (!this.srv) {
      this.srv = new BaseService("PUBLIC_REPLY_BACKEND_URL", 1000 * 60);
    }
    return this.srv.getInstance();
  }

  static async submitAvalancheReport(
    avalancheReport: AvalancheReport
  ): Promise<AxiosResponse<AvalancheReportResponse>> {
    // Custom submission. Generated code does not work out of the box.
    const formData = this.avalancheReportToFormData(avalancheReport);
    return this.getInstance().post("/public/avalanche", formData);
  }

  // eslint-disable-next-line max-statements
  private static avalancheReportToFormData(
    avalancheReport: AvalancheReport
  ): FormData {
    const formData = this.commonReportFieldsToFormData(avalancheReport);
    if (avalancheReport.comment != null) {
      formData.append("comment", avalancheReport.comment);
    }
    formData.append(
      "confidential",
      JSON.stringify(avalancheReport.confidential)
    );
    formData.append("avalancheSize", avalancheReport.avalancheSize);
    formData.append("avalancheType", avalancheReport.avalancheType);
    formData.append("triggerType", avalancheReport.triggerType);
    formData.append("avalancheMoisture", avalancheReport.avalancheMoisture);
    if (avalancheReport.triggerRemote != null) {
      formData.append(
        "triggerRemote",
        JSON.stringify(avalancheReport.triggerRemote)
      );
    }
    if (avalancheReport.materialDamage != null) {
      formData.append(
        "materialDamage",
        JSON.stringify(avalancheReport.materialDamage)
      );
    }
    if (avalancheReport.personDamage != null) {
      formData.append(
        "personDamage",
        JSON.stringify(avalancheReport.personDamage)
      );
    }
    if (avalancheReport.avalancheVictims) {
      formData.append(
        "avalancheVictims",
        JSON.stringify(avalancheReport.avalancheVictims)
      );
    }
    return formData;
  }

  static async submitObservationReport(
    observationReport: ObservationReport
  ): Promise<AxiosResponse<ObservationReportResponse>> {
    // Custom submission. Generated code does not work out of the box.
    const formData = this.observationReportToFormData(observationReport);
    return this.getInstance().post("/public/observation", formData);
  }

  private static observationReportToFormData(
    observationReport: ObservationReport
  ): FormData {
    const formData = this.commonReportFieldsToFormData(observationReport);
    if (observationReport.dangersign) {
      formData.append(
        "dangersign",
        JSON.stringify(observationReport.dangersign)
      );
    }
    if (observationReport.danger) {
      formData.append("danger", JSON.stringify(observationReport.danger));
    }
    if (observationReport.attachment) {
      formData.append(
        "attachment",
        JSON.stringify(observationReport.attachment)
      );
    }
    return formData;
  }

  private static commonReportFieldsToFormData(
    commonReportFields: CommonReportFields
  ): FormData {
    const formData = new FormData();
    formData.append("date", commonReportFields.date);
    formData.append("location", JSON.stringify(commonReportFields.location));
    formData.append(
      "contactInfo",
      JSON.stringify(commonReportFields.contactInfo)
    );
    if (commonReportFields.documents) {
      for (const file of commonReportFields.documents) {
        formData.append("documents", file, file.name);
      }
    }
    return formData;
  }
}
